<template>
  <v-list>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>인증번호</v-list-item-title>
        <v-text-field
          solo
          ref="refCode"
          type="password"
          label="인증번호"
          :height="formHeight"
          v-model="reqData.inputCode"
        >
          <template v-slot:append>
            {{ $helper.format_dp_time(startNumber) }}
          </template>
        </v-text-field>

        <span class="input-guide">
          회원가입 확인을 위한 휴대폰번호 인증을 진행합니다. 통신사 사정에 따라
          최대 5분 정도 소요될 수 있습니다.
        </span>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>
<script>
export default {
  props: {
    reqData: {
      type: Object,
    },
  },
  data() {
    return {
      formHeight: 52,
      defaultTime: 4 * 60,
      startNumber: 0,
      isSend: false,
      timer: {
        sDate: null,
        eDate: null,
        tik: 0,
        pointer: null,
        isPlaying: false,
      },
    };
  },
  mounted() {
    this.startTimer(true);
  },
  methods: {
    startTimer(isSend) {
      this.isSend = isSend;
      this.startNumber = this.defaultTime;
      this.timer.sDate = this.$moment();
      this.timer.isPlaying = true;
      this.timer.pointer = setInterval(() => {
        const currentTime = this.$moment();
        this.timer.tik = Math.floor(
          this.$moment.duration(currentTime.diff(this.timer.sDate)).asSeconds()
        );
        this.timer.eDate = this.$moment();
        this.startNumber--;
        if (this.startNumber === 0) {
          this.$emit("gotoSmsInput");
        }
        // console.log("", this.$helper.format_dp_time(this.startNumber));
      }, 1000);
    },
  },
};
</script>
<style lang="">
</style>